export default __webpack_public_path__ + "static/media/img1.e0bf7d12.jpeg";